import { useGetAdminUserBusinessByIdQuery } from 'app/services/user';
import { EditIcon, ViewIcon } from 'assets/icons';
import { CustomButton } from 'Components/Auth/CustomButton';
import Spinner from 'Components/Spinner';
import UserAvatar from 'Components/UserAvatar';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from 'utils/AuthProvider';
import BusinessesList from '../../businesses/BusinessesList';

export interface IViewBusinessDetailsProps {}

export default function ViewBusinessDetails(props: IViewBusinessDetailsProps) {
  const { isClient, userId } = useAuth();
  const { clientId } = useParams();
  const { data, isLoading } = useGetAdminUserBusinessByIdQuery(
    isClient ? +userId! : +clientId!,
  );

  if (!data) return <Spinner />;
  return <BusinessesList data={data} />;
}
